export default "__VITE_ASSET__46d4b128__"